// Utility to clear form cache while preserving essential data
export const clearFormCache = () => {
  try {
    const keysToRemove = [];
    
    // Get all localStorage keys
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      
      // Remove form-related data but preserve:
      // - Firebase/Google auth tokens
      // - User session data
      // - Theme preferences
      // - Any other non-form data
      if (key && (
        key.includes('form_autosave') ||
        key.includes('admin_dashboard') ||
        key.includes('student_form') ||
        key.includes('application_draft') ||
        key.includes('cached_form')
      )) {
        keysToRemove.push(key);
      }
    }
    
    // Remove the identified keys
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
      console.log(`🗑️ Removed cached form data: ${key}`);
    });
    
    if (keysToRemove.length > 0) {
      console.log(`✅ Cleared ${keysToRemove.length} form cache entries while preserving login sessions`);
    } else {
      console.log('ℹ️ No form cache found to clear');
    }
    
    return keysToRemove.length;
  } catch (error) {
    console.error('❌ Error clearing form cache:', error);
    return 0;
  }
};

// Clear all form data on app initialization (except login data)
export const initializeFormCacheClear = () => {
  console.log('🚨 CRITICAL: Clearing all form cache to prevent data loss incidents');
  return clearFormCache();
};
